import type { InputGroupPassThroughOptions } from "primevue/inputgroup";

export const inputgroup: InputGroupPassThroughOptions = {
  root: () => {
    return {
      class: [
        //layout
        "flex items-center",
        // color
        "bg-transparent"
      ]
    };
  }
};
